<template>
  <nav
    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar">
        <span class="navbar-toggler-icon"></span>
      </navbar-toggle-button>
      <router-link class="navbar-brand pb-0" to="/">
        <img :src="logo" class="navbar-brand-img" alt="Barter CLP" />
      </router-link>

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <base-dropdown class="nav-item" position="right">
            <a slot="title" class="nav-link" href="#" role="button">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle">
                  <img alt="CLP Logo" src="/img/brand/barter-logo.png" />
                </span>
              </div>
            </a>

            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">User</h6>
              </div>
              <router-link to="/admin/settings" class="dropdown-item">
                <i class="ni ni-settings-gear-65"></i>
                <span>Settings</span>
              </router-link>

              <router-link
                to="/admin/data-privacy-policy"
                class="dropdown-item"
              >
                <i class="fa fa-upload"></i>
                <span>Data Privacy Policy</span>
              </router-link>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item" @click="logout">
                <i class="ni ni-user-run"></i>
                <span>Logout</span>
              </a>
            </template>
          </base-dropdown>
        </ul>
      </slot>
      <slot></slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logo" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button
                @click.native="closeSidebar"
              ></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>

        <div v-if="checkPrivs('MemberProfile')">
          <!--Divider-->
          <hr class="my-3" />
          <h6 class="navbar-heading text-muted">Member Management</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <sidebar-item
              :link="{
                name: 'Member Profiles',
                icon: 'fa fa-users text-blue',
                path: '/admin/member-profiles'
              }"
            />
          </ul>
        </div>

        <div v-if="checkPrivs('PointsAdjustment')">
          <!--Divider-->
          <hr class="my-3" />
          <!--Heading-->
          <h6 class="navbar-heading text-muted">Points Management</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <sidebar-item
              :link="{
                name: 'Points Adjustments',
                icon: 'fa fa-tag text-green',
                path: '/admin/points-adjustments'
              }"
            />
          </ul>
        </div>

        <div v-if="checkPrivs('ItemRewards') || checkPrivs('ItemInventory')">
          <!--Divider-->
          <hr class="my-3" />
          <!--Heading-->
          <h6 class="navbar-heading text-muted">Item Management</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <div v-if="checkPrivs('ItemRewards')">
              <sidebar-item
                :link="{
                  name: 'Item Rewards',
                  icon: 'fa fa-tags text-purple',
                  path: '/admin/items'
                }"
              />
            </div>
            <div v-if="checkPrivs('ItemInventory')">
              <sidebar-item
                :link="{
                  name: 'Item Inventory',
                  icon: 'fa fa fa-tasks text-purple',
                  path: '/admin/item-inventory'
                }"
              />
            </div>
          </ul>
        </div>

        <div
          v-if="
            checkPrivs('CardInventory') ||
            checkPrivs('CardOrder') ||
            checkPrivs('CardReceive') ||
            checkPrivs('CardTransferOut') ||
            checkPrivs('CardTransferIn') ||
            checkPrivs('CardType') ||
            checkPrivs('CardSupplier')
          "
        >
          <!--Divider-->
          <hr class="my-3" />
          <!--Heading-->
          <h6 class="navbar-heading text-muted">Card Management</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <div v-if="checkPrivs('CardInventory')">
              <sidebar-item
                :link="{
                  name: 'Card Inventory',
                  icon: 'fa fa-id-card text-teal',
                  path: '/admin/card-inventory'
                }"
              />
            </div>

            <div v-if="checkPrivs('CardOrder')">
              <sidebar-item
                :link="{
                  name: 'Card Orders',
                  icon: 'fa fa-shopping-cart text-teal',
                  path: '/admin/card-orders'
                }"
              />
            </div>

            <div v-if="checkPrivs('CardReceive')">
              <sidebar-item
                :link="{
                  name: 'Card Receiving',
                  icon: 'fa fa-cart-arrow-down text-teal',
                  path: '/admin/card-receiving'
                }"
              />
            </div>

            <div v-if="checkPrivs('CardTransferOut')">
              <sidebar-item
                :link="{
                  name: 'Transfer Out',
                  icon: 'fa fa-outdent text-teal',
                  path: '/admin/transfer-out'
                }"
              />
            </div>

            <div v-if="checkPrivs('CardTransferIn')">
              <sidebar-item
                :link="{
                  name: 'Transfer In',
                  icon: 'fa fa-indent text-teal',
                  path: '/admin/transfer-in'
                }"
              />
            </div>

            <div v-if="checkPrivs('CardType')">
              <sidebar-item
                :link="{
                  name: 'Card Types',
                  icon: 'fa fa-list-ul text-teal',
                  path: '/admin/card-types'
                }"
              />
            </div>

            <div v-if="checkPrivs('CardSupplier')">
              <sidebar-item
                :link="{
                  name: 'Card Suppliers',
                  icon: 'fa fa-th-list text-teal',
                  path: '/admin/card-suppliers'
                }"
              />
            </div>
          </ul>
        </div>
        <div v-if="checkPrivs('CardSellingType') || checkPrivs('PaymentType')">
          <!--Divider-->
          <hr class="my-3" />
          <!--Heading-->
          <h6 class="navbar-heading text-muted">Card Selling Management</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <div v-if="checkPrivs('CardSellingType')">
              <sidebar-item
                :link="{
                  name: 'Card Selling Types',
                  icon: 'fa fa-list-ul text-teal',
                  path: '/admin/card-selling-types'
                }"
              />
            </div>
            <div v-if="checkPrivs('PaymentType')">
              <sidebar-item
                :link="{
                  name: 'Payment Types',
                  icon: 'fa fa-th-list text-teal',
                  path: '/admin/payment-types'
                }"
              />
            </div>
          </ul>
        </div>
        <div v-if="checkPrivs('Site')">
          <!--Divider-->
          <hr class="my-3" />
          <!--Heading-->
          <h6 class="navbar-heading text-muted">Site Management</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <div v-if="checkPrivs('Site')">
              <sidebar-item
                :link="{
                  name: 'Site',
                  icon: 'fa fa-columns text-yellow',
                  path: '/admin/sites'
                }"
              />
            </div>
          </ul>
        </div>
        <div v-if="checkPrivs('SitePage')">
          <!--Divider-->
          <hr class="my-3" />
          <!--Heading-->
          <h6 class="navbar-heading text-muted">Site Page Management</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <div v-if="checkPrivs('SitePage')">
              <sidebar-item
                :link="{
                  name: 'Site Pages',
                  icon: 'fa fa-columns text-yellow',
                  path: '/admin/site-pages'
                }"
              />
            </div>
          </ul>
        </div>

        <div
          v-if="
            checkPrivs('MembershipProgram') ||
            checkPrivs('MembershipProgramV2') ||
            checkPrivs('MembershipLevel') ||
            checkPrivs('MemberStatus') ||
            checkPrivs('MemberTag') ||
            checkPrivs('InteractionType') ||
            checkPrivs('Messages') ||
            checkPrivs('CustomerType') ||
            checkPrivs('AdjustmentReasonType')
          "
        >
          <!--Divider-->
          <hr class="my-3" />
          <!--Heading-->
          <h6 class="navbar-heading text-muted">Profile Management</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <div v-if="checkPrivs('MembershipProgram')">
              <sidebar-item
                :link="{
                  name: 'Membership Programs V1',
                  icon: 'fa fa-address-book text-orange',
                  path: '/admin/membership-programs'
                }"
              />
            </div>
            <div v-if="checkPrivs('MembershipProgramV2')">
              <sidebar-item
                :link="{
                  name: 'Membership Programs',
                  icon: 'fa fa-address-book text-orange',
                  path: '/admin/membership-programs-v2'
                }"
              />
            </div>

            <div v-if="checkPrivs('MembershipLevel')">
              <sidebar-item
                :link="{
                  name: 'Membership Levels',
                  icon: 'fa fa-list text-orange',
                  path: '/admin/membership-levels'
                }"
              />
            </div>

            <div v-if="checkPrivs('MemberStatus')">
              <sidebar-item
                :link="{
                  name: 'Member Statuses',
                  icon: 'fa fa-user text-orange',
                  path: '/admin/member-statuses'
                }"
              />
            </div>

            <div v-if="checkPrivs('CustomerType')">
              <sidebar-item
                :link="{
                  name: 'Customer Types',
                  icon: 'fa fa-th-list text-orange',
                  path: '/admin/customer-types'
                }"
              />
            </div>
            <div v-if="checkPrivs('MemberTag')">
              <sidebar-item
                :link="{
                  name: 'Member Tags',
                  icon: 'fa fa-tag text-orange',
                  path: '/admin/member-tags'
                }"
              />
            </div>

            <div v-if="checkPrivs('InteractionType')">
              <sidebar-item
                :link="{
                  name: 'Interaction Types',
                  icon: 'fa fa-comments text-orange',
                  path: '/admin/interaction-types'
                }"
              />
            </div>

            <div v-if="checkPrivs('Messages')">
              <sidebar-item
                :link="{
                  name: 'Sales Invoice Text',
                  icon: 'fa fa-comment text-orange',
                  path: '/admin/messages'
                }"
              />
            </div>
            <div v-if="checkPrivs('AdjustmentReasonType')">
              <sidebar-item
                :link="{
                  name: 'Adjustment Reason Types',
                  icon: 'fa fa-list-alt text-orange',
                  path: '/admin/adjustment-reason-types'
                }"
              />
            </div>
          </ul>
        </div>
        <div v-if="checkPrivs('ScratchCard')">
          <!--Divider-->
          <hr class="my-3" />
          <h6 class="navbar-heading text-muted">Gamification</h6>
          <!--Navigation-->

          <ul class="navbar-nav">
            <div v-if="checkPrivs('ScratchCard')">
              <sidebar-item
                :link="{
                  name: 'Scratch Card',
                  icon: 'fa fa-gamepad text-blue',
                  path: '/admin/games/scratch-card'
                }"
              />
            </div>
          </ul>
        </div>
        <div v-if="checkPrivs('Promotion') || checkPrivs('Voucher')">
          <!--Divider-->
          <hr class="my-3" />
          <h6 class="navbar-heading text-muted">Promotion Management</h6>
          <!--Navigation-->

          <ul class="navbar-nav">
            <div v-if="checkPrivs('Promotion')">
              <sidebar-item
                :link="{
                  name: 'Promotions',
                  icon: 'fa fa-tags text-blue',
                  path: '/admin/promotions'
                }"
              />
            </div>
          </ul>
          <ul class="navbar-nav">
            <div v-if="checkPrivs('Voucher')">
              <sidebar-item
                :link="{
                  name: 'Voucher',
                  icon: 'fa fa-tag text-blue',
                  path: voucherURL,
                  target: '_blank'
                }"
              />
            </div>
          </ul>
        </div>

        <div v-if="checkPrivs('User') || checkPrivs('UserGroup')">
          <!--Divider-->
          <hr class="my-3" />
          <h6 class="navbar-heading text-muted">User Management</h6>
          <!--Navigation-->

          <ul class="navbar-nav">
            <div v-if="checkPrivs('User')">
              <sidebar-item
                :link="{
                  name: 'Users',
                  icon: 'fa fa-user text-blue',
                  path: '/admin/users'
                }"
              />
            </div>
            <div v-if="checkPrivs('UserGroup')">
              <sidebar-item
                :link="{
                  name: 'User Groups',
                  icon: 'fa fa-users text-blue',
                  path: '/admin/user-groups'
                }"
              />
            </div>
          </ul>
        </div>

        <div
          v-if="
            checkPrivs('CardReport') ||
            checkPrivs('TransactionReport') ||
            checkPrivs('AuditLogsReport') ||
            checkPrivs('CustomerInteractionReport') ||
            checkPrivs('CustomerInfoReport') ||
            checkPrivs('CardSellingReport') ||
            checkPrivs('ItemRewardsReport')
          "
        >
          <!--Divider-->
          <hr class="my-3" />

          <h6 class="navbar-heading text-muted">Reports</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <div
              v-if="
                checkPrivs('CardReport') &&
                ['prg', 'clp-prguat', 'prg-non-bxi'].includes(accountName)
              "
            >
              <sidebar-item
                :link="{
                  name: 'PRG Cards',
                  icon: 'fa fa-address-card text-yellow',
                  path: '/admin/reports/cards-temp'
                }"
              />
            </div>

            <div v-if="checkPrivs('CardReport')">
              <sidebar-item
                :link="{
                  name: 'Cards',
                  icon: 'fa fa-address-card text-yellow',
                  path: '/admin/reports/cards'
                }"
              />
            </div>
            <div v-if="checkPrivs('TransactionReport')">
              <sidebar-item
                :link="{
                  name: 'Transactions',
                  icon: 'fa fa-list-alt text-yellow',
                  path: '/admin/reports/transactions'
                }"
              />
            </div>
            <div v-if="checkPrivs('CustomerInfoReport')">
              <sidebar-item
                :link="{
                  name: 'Customer Information',
                  icon: 'fa fa-user text-yellow',
                  path: '/admin/reports/customers-info'
                }"
              />
            </div>

            <div v-if="checkPrivs('CustomerInteractionReport')">
              <sidebar-item
                :link="{
                  name: 'Customer Interactions',
                  icon: 'fa fa-list-ul text-yellow',
                  path: '/admin/reports/customer-interaction-logs'
                }"
              />
            </div>
            <div v-if="checkPrivs('AuditLogsReport')">
              <sidebar-item
                :link="{
                  name: 'Audit Logs',
                  icon: 'fa fa-list-ul text-yellow',
                  path: '/admin/reports/audit-logs'
                }"
              />
            </div>
            <div v-if="checkPrivs('ItemRewardsReport')">
              <sidebar-item
                :link="{
                  name: 'Item Rewards Inventory',
                  icon: 'fa fa fa-tasks text-yellow',
                  path: '/admin/reports/item-rewards-inventory'
                }"
              />
            </div>
            <div v-if="checkPrivs('CardSellingReport')">
              <sidebar-item
                :link="{
                  name: 'Card Selling',
                  icon: 'fa fa-list-alt text-yellow',
                  path: '/admin/reports/card-selling'
                }"
              />
            </div>
            <div v-if="checkPrivs('ScratchCardReport')">
              <sidebar-item
                :link="{
                  name: 'Scratch Card',
                  icon: 'fa fa-list-alt text-yellow',
                  path: '/admin/reports/scratch-card'
                }"
              />
            </div>
          </ul>
        </div>

        <div
          v-if="
            checkPrivs('CustomizedFields') || checkPrivs('CustomizedSettings')
          "
        >
          <!--Divider-->
          <hr class="my-3" />
          <!--Heading-->
          <h6 class="navbar-heading text-muted">Advanced Settings</h6>
          <!--Navigation-->
          <ul class="navbar-nav">
            <div v-if="checkPrivs('CustomizedFields')">
              <sidebar-item
                :link="{
                  name: 'Member Customized Fields',
                  icon: 'fa fa-columns text-yellow',
                  path: '/admin/custom-fields'
                }"
              />
            </div>

            <div v-if="checkPrivs('CustomizedSettings')">
              <sidebar-item
                :link="{
                  name: 'CLP Customized Settings',
                  icon: 'fa fa-columns text-yellow',
                  path: '/admin/custom-settings'
                }"
              />
            </div>
          </ul>
        </div>
        <!--Divider-->
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarToggleButton from '@/components/NavbarToggleButton';
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest';

export default {
  name: 'sidebar',
  components: {
    NavbarToggleButton
  },
  props: {
    logo: {
      type: String,
      default: '/img/brand/bxi-clp-blue-logo.png',
      description: 'Sidebar app logo'
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  mounted: async function () {
    const url = '/api/auth/users/me';
    const data = await HTTPRequest.getRequest(url);

    if (typeof data.error !== 'undefined' && data.error == 'Unauthorized') {
      this.$router.push({ name: 'Login' });
    }
    this.accountName = data.account_name;
    // this.accountName = secureStorage.getItem('currentAccountName')
    secureStorage.setItem('username', data.username);
  },
  data() {
    return {
      accountName: null,
      hasCardAssignmentModule: false
    };
  },
  methods: {
    async getCardAssignmentFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_ASSIGNMENT_FEATURE`
      );

      if (response.account_id) {
        this.hasCardAssignmentModule = response.value == 'true';
      }
    },
    checkPrivs(mod) {
      let show = false;
      let acc = this.$store.getters.getAccount;
      if (acc?.modules) {
        const module = acc.modules.find(function (module) {
          if (module.systemModule.name == mod) return true;
        });

        if (typeof module !== 'undefined') {
          let _selectedActions = module.selected_actions.split('|');
          if (
            _selectedActions.includes('View') ||
            _selectedActions.includes('Activate') ||
            _selectedActions.includes('Receive')
          )
            show = true;
        }
      }
      if (this.hasCardAssignmentModule) {
        const hideModule = [
          'CardOrder',
          'CardReceive',
          'CardTransferOut',
          'CardTransferIn',
          'CardType',
          'CardSupplier'
        ];
        if (hideModule.includes(mod)) {
          show = false;
        }
      }
      // console.log('Checking Module -- ' + mod);
      // console.log(show);
      return show;
    },
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    logout() {
      secureStorage.clear();

      if (
        secureStorage.getItem('bxiClpAccessToken') == null ||
        secureStorage.getItem('bxiClpAccessToken') == undefined
      ) {
        this.$notification.success({
          message: 'Successfully logged out.'
        });

        setTimeout(() => {
          window.close();
          this.$router('/admin/login');
        }, 3000);
      }

      console.log('logout');
    }
  },
  async created() {
    await this.getCardAssignmentFeature();
  },
  computed: {
    voucherURL() {
      let source = secureStorage.getItem('source');
      const voucherUrl =
        process.env.VUE_APP_VOUCHER != undefined
          ? `${
              process.env.VUE_APP_VOUCHER
            }/login?vToken="${secureStorage.getItem(
              'bxiClpAccessToken'
            )}"&uToken="${secureStorage.getItem(
              'uploadToken'
            )}"&source=${source}`
          : '/admin/vouchers';
      return voucherUrl;
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
